import { render } from "./BannerVideoZoom.vue?vue&type=template&id=2475c5de&scoped=true"
import script from "./BannerVideoZoom.vue?vue&type=script&lang=js"
export * from "./BannerVideoZoom.vue?vue&type=script&lang=js"

import "./BannerVideoZoom.vue?vue&type=style&index=0&id=2475c5de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2475c5de"]])

export default __exports__